module.exports = __webpack_public_path__ + "static/img/yasuo_1@2x.c4cbdf24.png";